export class Chapter {
  public verses: string[][];
  public verseNumbers: number[];
  public nameEnglish: string;
  public nameTrans: string;
  public nameArabic: string;
  public chapterNumber: number;
  public textBooks: string[];
}
